import peiStatus from '@/utils/constants/pei/peiStatus';
import { ValidationManager } from '@/components/pei/programservice/ValidationManager';
const TAB_ID = 'Tab4';

export default {
  userRole: function(state) {
    return state.userProfile.role;
  },
  userCenters: function(state) {
    return state.userProfile.centerId;
  },
  GetActiveATTab: function(state) {
    return state.activeATTab;
  },
  WebServiceStudentSearchEnabled: function(state) {
    return state.webServiceStudentSearchEnabled;
  },
  SelectedStudentMustHaveRegistration: function(state) {
    return state.$_student.selectedStudentMustHaveRegistration;
  },
  //TODO Student:(We nedd migrate this, but has a lot dependencies)
  SelectedStudent: function(state) {
    return state.$_student.selectedStudent;
  },
  getAtConversionValue: function(state) {
    return state.$_student.selectedStudent?.isAtConverted;
  },
  IsValidSelectedStudent: function(state) {
    return state.$_student.selectedStudent == null ? false : true;
  },
  // END TODO
  getHasTapRequest: (state) => state.hasTapRequest,
  getShowTapRequestAlert: (state) => state.showTapRequestAlert,
  getValidateTapRequest: (state) => state.validateTapRequest,
  getProvisionalRemedyRequest: function(state) {
    return state.ProvisionalRemedyRequest;
  },
  //Pei Methods:
  getProvisionalRemedyRequestRef: function(state) {
    return state.ProvisionalRemedyRequestRef;
  },
  SelectedPei: function(state) {
    return state.peiSelected;
  },
  SelectedPeiStatus: function(state) {
    return state.pei.peiStatusCode;
  },
  SelectedPeiLocationRejected: function(state) {
    return state.pei.peiLocationRejected;
  },
  getPeiInfo: function(state) {
    return state.pei;
  },
  getPeiATAmmendmentInfo: function(state) {
    return state.peiATAmmendment;
  },
  getIsPs: function(state) {
    return state.pei.configUnilateralFlag == '1';
  },
  getIsPsc: function(state) {
    return state.pei.configUnilateralFlag == '2';
  },
  getPeiHasAcademicAreas: function(state) {
    return state.peiHasAcademicAreas;
  },
  getPeiHasAlternativeAcademicUbications: function(state) {
    return state.peiHasAlternativeAcademicUbications;
  },
  getConfigAcademicYearId: function(state) {
    return state.pei.academicYearId;
  },
  PreviousPeiId: function(state) {
    return state.pei.previousPeiId;
  },
  // Get the controversy of a specific section.
  getPeiControversies: function(state) {
    return function(sectionId) {
      if (
        state.pei.controversies &&
        state.pei.controversies.peiControversySections
      ) {
        let controversy = state.pei.controversies.peiControversySections.find(
          (c) => c.sectionId == sectionId
        );
        return {
          controversy: controversy,
          existControversy: controversy
            ? controversy.sectionControversyAnswer
            : false,
          informationMessage: controversy
            ? controversy.sectionControversyComment
            : '',
        };
      }
      return null;
    };
  },
  // Get property showSignSection from peiTab1.
  getVisiblePeiSignSection: function(state) {
    return state.peiTab1.showSignSection;
  },
  // End PEI
  SelectedAt: function(state) {
    return state.atSelected;
  },
  RedirectAtFrom: function(state) {
    return state.redirectAtFrom;
  },
  HasPermission: (state) => (permissionName) => {
    if (state.$_user.permissions != null) {
      return state.$_user.permissions.some((permission) => {
        return permission == permissionName;
      });
    }
    return false;
  },
  // Affirmative Letter
  SelectedPeiAffirmativeLetter: (state) => {
    return state.peiAffirmativeLetterSelected;
  },
  //Preliminary methods
  SelectPreEvalAnswer: function(state) {
    return state.preEvaluationAnswer;
  },
  SelectRecentlyEvalBy: function(state) {
    return state.recentlyEvaluatedBy;
  },
  getatValidationTriggered: function(state) {
    return state.atValidationTriggered;
  },
  getAtCompleted: function(state) {
    return state.atCompleted;
  },
  getServiceTypeId: function(state) {
    return state.serviceTypeId;
  },
  getPeiValidationTriggered: function(state) {
    return {
      validation: state.peiValidationTriggered.validation,
      tabValidation: state.peiValidationTriggered.tabValidation,
      errors: function(tabId, errorId) {
        if (state.peiValidationTriggered.tabValidation) {
          let tab = state.peiValidationTriggered.tabValidation.find(
            (tabVal) => tabVal.id == tabId
          );
          if (tab) {
            let error = tab.errors.find((error) => error.id == errorId);
            return error ? error.name : null;
          }
        }
        return null;
      },
      getPvAlerts: function(tabId) {
        ///Alertas para las secciones del PEI que son validaciones de negocio A.L
        if (state.peiValidationTriggered.tabValidation) {
          let tab = state.peiValidationTriggered.tabValidation.find(
            (tabVal) => tabVal.id == tabId
          );
          let alerts = tab.errors.filter(function(error) {
            if (error.id.toLowerCase().includes('pv-')) {
              return error;
            }
          });
          if (alerts.length > 0) {
            return alerts;
          } else {
            return null;
          }
        }
        return null;
      },
      // Para el caso de ProgramServiceArea, el id llega en el error.id para identificar un area con errores
      hasErrors: function(tabId, errorId) {
        if (state.peiValidationTriggered.tabValidation) {
          let tab = state.peiValidationTriggered.tabValidation.find(
            (tabVal) => tabVal.id == tabId
          );
          if (tab) {
            let error = tab.errors.find((error) => error.id == errorId);
            return error ? true : false;
          }
        }
      },
      // Get property showSignSection from peiTab1.
      getVisiblePeiSignSection: function(state) {
        return state.peiTab1.showSignSection;
      },
      // End PEI
      atSaveBtnDisabled: (state) => {
        return state.atSaveBtnDisabled;
      },
      SelectedAt: function(state) {
        return state.atSelected;
      },
      HasPermission: (state) => (permissionName) => {
        if (state.userProfile.permissions != null) {
          return state.userProfile.permissions.some((permission) => {
            return permission == permissionName;
          });
        }
        return false;
      },
    };
  },
  tab4Validator: function(state) {
    return new ValidationManager(
      state.peiValidationTriggered?.tabValidation?.find(
        (x) => x.id == TAB_ID
      )?.errors,
      state.peiValidationTriggered?.validation
    );
  },
  tab6Errors: function(state) {
    return state.peiValidationTriggered?.tabValidation?.find(
      (x) => x.id == 'Tab6'
    )?.errors;
  },
  tab11Validator: function(state) {
    return new ValidationManager(
      state.peiValidationTriggered?.tabValidation?.find(
        (x) => x.id == 'Tab11'
      )?.errors,
      state.peiValidationTriggered?.validation
    );
  },
  //Pei Analisys Service Transportation
  getAnalysisServiceId: function(state) {
    return state.analysisServiceId;
  },
  getPeiTransportationInfo: function(state) {
    return state.peiTransportationInfo;
  },
  canChangeTransportationType: function(state, getters) {
    let hasPermission = getters.HasPermission('pei.edittransportationtype');
    return hasPermission && state.pei.peiStatusCode == peiStatus.Borrador;
  },
  selectedAreaExtended: function(state) {
    return state.areaExtendedSelected;
  },
  getPeiTab2Information: function(state) {
    return state.peiTab2;
  },
  getExit: (state) => state.exit,
  getIsNavOpen: (state) => state.isNavOpen,
  getIsMobileDensity: (state) => state.isMobileDensity,
  getIsAiAssistantDocked: (state) => state.aiAssistantDocked,
  userCentersAssigned(state) {
    return (listOfCenters) => {
      if (listOfCenters.length > 0) {
        const assignedCentersIds =
          state.userProfile?.user?.centerId ?? state.userProfile.centerId;
        if (assignedCentersIds) {
          const _centers = assignedCentersIds
            .split(',')
            .map((s) => parseInt(s.trim()));
          if (_centers.length > 0) {
            const _assignedCenters = listOfCenters
              .map(({ id, name }) => ({ id, name }))
              .filter((s) => {
                return _centers.includes(s.id);
              });
            return _assignedCenters;
          }
        }
        return listOfCenters;
      }
      return [];
    };
  },
  canShowRefreshSignatureTab: (state) => state.showRefreshSignatureTab,
  justSaveTab10: (state) => state.justSaveTab10,
  getShowSignatureCancellationDocument: (state) =>
    state.pei.showSignatureCancellationDocument,
  getIsDigitalSignatureCancelled: (state) =>
    state.pei.isDigitalSignatureCancelled,
  getTab10IsEnabled: (state) => state.pei.tab10IsEnabled,
  getShowDigitalSignatureActions: (state) => state.showDigitalSignatureActions,
  isCompuFileParameterEnable: (state) =>
    state.peiTab10.isCompuFileParameterEnable,
  isSignedPeiParameterEnable: (state) =>
    state.peiTab10.isCompuFileParameterEnable &&
    state.peiTab10.isSignedPeiParameterEnable,
  getRequireUsageGuaranteeCompletionEnabled: (state) =>
    state.requireUsageGuaranteeCompletionEnabled,
  getSignatureDocument: (state) => state.signatureDocument,
  getTab10SignatureInfo: (state) => state.tab10SignatureInfo,
  activeEducationalCompensatoryService: (state) =>
    state.activeEducationalCompensatoryService,
  triannualEvaluation: (state) => state.triannualEvaluation,
  registryTriannualEvaluation: (state) => state.registryTriannualEvaluation,
  registryTriannualEvaluationList: (state) =>
    state.registryTriannualEvaluationList,
};
